/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import axios from "axios";
import {
  listeVehiculeURL,
  itemVehiculeURL,
  delVehiculeURL,
  listeVehiculeByUserURL,
} from "config/api";
import { addVehiculeURL, updateVehiculeURL } from "config/api";
import { encryptStorage } from "components/EncryptedStorage/encryptedStorage";

export const getListVehicule = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  const email = await encryptStorage.getItem("userInfo").userName;

  return axios
    .post(listeVehiculeURL, data.client, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getListVehiculeForCustomer = async () => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  const email = await encryptStorage.getItem("userInfo").userName;

  //console.log("data ", data)

  const dataToSend = { email: email };
  return axios
    .post(listeVehiculeByUserURL, dataToSend, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getItemVehicule = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  const dataToSend = {
    identifiantVehicule: data.numeroVehicule,
  };

  return axios
    .post(itemVehiculeURL, dataToSend, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const addVehiculeService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  return axios
    .post(addVehiculeURL, data.vehicule, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const updateVehiculeService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  return axios
    .put(updateVehiculeURL, data.vehicule, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const deleteVehiculeService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  return axios
    .post(delVehiculeURL, data.vehicule, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};
